import { withFormikAdapter } from 'utils'
import { CheckboxGroup } from 'lp-components'

export default withFormikAdapter()(CheckboxGroup)
